var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilterIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9923 17.7452C10.8136 17.7451 10.6383 17.6961 10.4855 17.6034L7.22398 15.6468C6.85701 15.4255 6.55325 15.1134 6.34197 14.7405C6.1307 14.3677 6.01905 13.9467 6.01777 13.5181V9.09147C6.0184 8.77905 5.92125 8.47427 5.73995 8.21984L1.18611 1.82001C1.07978 1.67227 1.01632 1.49802 1.00275 1.3165C0.989178 1.13498 1.02602 0.953234 1.1092 0.791322C1.19238 0.62941 1.31867 0.493624 1.47414 0.398946C1.62961 0.304269 1.80822 0.25438 1.99025 0.254785H16.0088C16.191 0.254025 16.3698 0.303697 16.5255 0.398299C16.6812 0.492901 16.8077 0.628743 16.8909 0.790784C16.9742 0.952826 17.0109 1.13475 16.9972 1.3164C16.9834 1.49805 16.9197 1.67236 16.813 1.82001L12.2591 8.21984C12.0775 8.47415 11.98 8.77894 11.9803 9.09147V16.7552C11.9801 17.0174 11.8759 17.2687 11.6908 17.4543C11.5056 17.6398 11.2544 17.7444 10.9923 17.7452ZM1.99025 1.23794L6.53626 7.65244C6.83754 8.07158 6.99848 8.57529 6.99604 9.09147V13.5172C6.9964 13.7768 7.06387 14.032 7.19191 14.2579C7.31995 14.4838 7.50421 14.6728 7.72681 14.8065L10.9883 16.763L11.002 9.09049C10.9999 8.57421 11.1612 8.07048 11.4628 7.65146L16.0157 1.25164L1.99025 1.23794Z",
    fill: "#555555",
    stroke: "#555555",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterIcon);
export default __webpack_public_path__ + "static/media/filter-icon.363a2ca53be41922741a9307c82f963a.svg";
export { ForwardRef as ReactComponent };